<template>
  <div class="main-nav">
    <div class="main-login">
      <img v-if="defaultLogo" :src="publicData.u_url" alt />
      <span v-else class="logo_text">{{ logoText }}</span>
    </div>
    <!-- <el-menu
      mode="horizontal"
      default-active="1"
      class="el-menu-vertical-demo"
      background-color="#001529"
      text-color="rgba(255,255,255, .65)"
      active-text-color="#fff"
      router
    >
      <el-menu-item v-for="(item, idx) in nav_top" :key="idx" :index="item.url">
        <i :class="item.icon"></i>
        <span slot="title">{{ item.title }}</span>
      </el-menu-item>
    </el-menu>-->
    <div class="header-Nav" v-if="!pageLimit.status">
      <template v-for="(item, idx) in nav_top">
        <div
          class="header-Nav-option"
          :key="idx"
          @click="changeUrl(item, idx)"
          :style="{ color: active == idx ? '#ffffff' : '' }"
        >
          <i :class="item.icon"></i>
          <span>{{ item.title }}</span>
        </div>
      </template>
    </div>
    <div class="delet" @click="IsShowDeletOrder"></div>
    <div class="main-logout">
      <el-button type="text" style="color: #fff;" @click="logout()">
        退出
      </el-button>
    </div>
    <!-- <div class="notice-container">
      <div class="header-notice-marquee" id="notice-marquee">
        <span class="header-marquee-item1">这是一长串数据</span>
        <span class="header-marquee-item2">这是一长串数据</span>
      </div>
    </div>  -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="15%"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <el-input v-model="psw" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="clocan">取 消</el-button>
        <el-button type="primary" @click="queding">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { vipData } from '@/views/sidebar/sidebar.js/vipData'
export default {
  computed: {
    ...mapGetters(['status', 'app_id', 'publicData', 'pageLimit']),
  },
  data() {
    return {
      dialogVisible: false,
      IsShow: 0,
      is_yzb: false,
      is_normal: true,
      is_jbxx: false,
      active: '0',
      defaultLogo: false, // 默认logo zltc
      logoText: '', // 自定义logo部位的文字
      nav_top: [
        // {
        //   icon: "el-icon-location",
        //   title: "应用中心",
        //   url: "/apply/viewapp"
        // },
        {
          icon: 'el-icon-s-home',
          title: '会员系统',
          url: '/apply/newVip/13/home/vipIndex',
        },
        // {
        //   icon: "el-icon-user-solid",
        //   title: "用户中心",
        //   url: "/user"
        // },
        {
          icon: 'el-icon-document',
          title: '配置信息',
          url: '/configuration',
        },
        {
          icon: 'el-icon-document',
          title: '活动中心',
          url: '/activeCenter',
        },
        {
          icon: 'el-icon-document',
          title: '分销设置',
          url: '/apply/distribute/10/general',
        },
        {
          icon: 'el-icon-setting',
          title: '编辑',
          url: '',
        },
      ],
      psw: '', //删除列表密码:20211207  配置信息密码:20211223
    }
  },
  mounted() {
    this.reset()
  },
  methods: {
    clocan() {
      this.psw = ''
      this.IsShow = 0
      this.dialogVisible = false
    },
    queding() {
      if (this.psw == '20211207') {
        vipData.forEach((e,i) => {
          if (e.name == '订单') {
            if (e.children.findIndex((x) => x.name == '删除订单列表') == -1) {
             
              e.children.push({
                path: '/apply/newVip/13/order/orderDelteList',
                name: '删除订单列表',
              })
            }
          }
        })
        this.psw = ''
        this.dialogVisible = false
      } else if (this.psw == '20211223') {
        this.psw = ''
        this.dialogVisible = false
        setTimeout(() => {
          this.$router.push('/configuration')
        }, 500)
      } else {
        this.$message.error('输入不正确请联系平台管理员!!!')
      }
    },
    logout() {
      localStorage.clear()
      // localStorage.removeItem('app_id')
      // localStorage.removeItem('token')
      if (this.status == 'test') {
        window.location.href =
          'https://cs.58zltc.com/#/login?redirect=%2Fmanage%2Fcenter'
      } else if (this.status == 'online') {
        window.location.href =
          'https://www.58zltc.com/#/login?redirect=%2Fmanage%2Fcenter'
      }
      // this.$router.push('/login')
    },
    changeUrl(item, index) {
      if (item.title === '配置信息') {
        this.dialogVisible = true
      } else {
        this.$router.push(item.url)
      }
      this.active = index
    },
    IsShowDeletOrder() {
      this.IsShow++
      if (this.IsShow == 6) {
        this.dialogVisible = true
      }
    },
    reset() {
      console.log('22222')
      if (this.app_id == '387') {
        this.nav_top.unshift({
          icon: 'el-icon-location',
          title: '应用中心',
          url: '/apply/viewapp',
        })
      }

      if (
        this.app_id == '437' ||
        this.app_id == '439' ||
        this.app_id == '440' ||
        this.app_id == '430'
      ) {
        // this.is_yzb = true;
        // this.is_normal = false;
        // this.is_jbxx = false;
        this.defaultLogo = false
        this.logoText = '油站帮'
      } else if (this.app_id == '432' || this.app_id == '427') {
        // this.is_normal =false;
        // this.is_yzb = false;
        // this.is_jbxx = true;
        this.defaultLogo = false
        this.logoText = '京标信息'
      } else {
        // this.is_yzb = false;
        // this.is_normal = true;
        // this.is_jbxx = false;

        if (this.publicData.a_title && this.publicData.u_url) {
          this.defaultLogo = true
        } else {
          if (this.publicData.a_title) {
            if (this.publicData.u_url == '') {
              this.logoText = this.publicData.a_title
            }
          }
        }

        //
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.main-nav {
  width: 100%;
  height: 60px;
  display: flex;
  display: -webkit-box;
  position: relative;
  align-items: center;
  background: rgb(0, 21, 41);
  .main-login {
    width: 160px;
    height: 32px;
    margin-left: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .header-Nav {
    height: 100%;
    display: flex;
    margin-left: 48px;
    .changeAddress {
      display: flex;
      align-items: center;
    }
    .header-Nav-option {
      min-width: 124px;
      font-size: 14px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      color: rgba(255, 255, 255, 0.65);
      cursor: pointer;

      span {
        margin-left: 8px;
      }

      i {
        font-size: 20px;
      }
    }
  }
  .main-logout {
    position: absolute;
    top: 10px;
    right: 10px;
    height: 40;
    line-height: 40px;
    color: #fff;
  }

  .el-menu-vertical-demo {
    margin-left: 50px;
    .is-active,
    .el-menu-item {
      border-bottom: none;
    }
  }
  .el-header {
    padding: 0;
  }
  .logo_text {
    margin-left: 20px;
    font-size: 24px;
    font-weight: bold;
    line-height: 32px;
    letter-spacing: 4px;
    display: inline-block;
    color: #fff;
  }
}
.notice-container {
  padding: 0 10px;
  align-items: center;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  width: 110px;
}
.header-notice-marquee {
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 20px;
  line-height: 20px;
}
.notice-container .header-marquee-item1 {
  margin: 0 10px;
  position: absolute;
  left: 0;
  animation: a 15s linear 8;
}

.notice-container .header-marquee-item2 {
  margin: 0 10px;
  position: absolute;
  left: 0;
  animation: b 15s linear 8;
}
.notice-container .header-notice-marquee .header-marquee-item {
  position: absolute;
  top: 0;
  left: 0;
  white-space: nowrap;
}

@keyframes a {
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}

@keyframes b {
  0% {
    left: 100%;
  }
  100% {
    left: 0%;
  }
}
.delet {
  width: 40%;
  height: 100%;
}
</style>
